const levelsList = [
    ['Standard', 'Standard'],
    ['Further', 'Further'],
    ['Foundation', 'Foundation'],
]

export {levelsList}